import React, { createContext, useContext, useEffect, useState } from 'react'

let auth = null
let onAuthStateChanged = null
let signInWithPopup = null
let GoogleAuthProvider = null
let signOut = null

// Only import Firebase on client-side
if (typeof window !== 'undefined') {
  const firebaseAuth = require('firebase/auth')
  const firebaseConfig = require('../firebase/config')
  auth = firebaseConfig.auth
  onAuthStateChanged = firebaseAuth.onAuthStateChanged
  signInWithPopup = firebaseAuth.signInWithPopup
  GoogleAuthProvider = firebaseAuth.GoogleAuthProvider
  signOut = firebaseAuth.signOut
}

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (typeof window !== 'undefined' && auth && onAuthStateChanged) {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        setUser(user)
        setLoading(false)
      })

      return unsubscribe
    } else {
      setLoading(false)
    }
  }, [])

  const signInWithGoogle = async () => {
    if (typeof window === 'undefined' || !auth || !signInWithPopup || !GoogleAuthProvider) {
      throw new Error('Firebase is not available')
    }
    const provider = new GoogleAuthProvider()
    try {
      const result = await signInWithPopup(auth, provider)
      return result.user
    } catch (error) {
      console.error('Error signing in with Google:', error)
      // Server-side blocking function will handle domain restriction
      throw error
    }
  }

  const logout = async () => {
    if (typeof window === 'undefined' || !auth || !signOut) {
      throw new Error('Firebase is not available')
    }
    try {
      await signOut(auth)
    } catch (error) {
      console.error('Error signing out:', error)
      throw error
    }
  }

  const value = {
    user,
    loading,
    signInWithGoogle,
    logout
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}